<template>
    <div class="incident-risk-types-filters">
        <app-sub-title text="Filtros" />
        <b-card>
            <div class="card-text">
                <b-row>
                    <b-col cols="12" md="3">
                        <app-form-select-input
                            placeholder="Tipo"
                            :options="typeOptions"
                            v-model="type"
                        />
                    </b-col>
                    <b-col cols="12" md="3">
                        <app-form-text-input
                            placeholder="Nombre"
                            v-model="name"
                        />
                    </b-col>
                    <b-col cols="12" md="3">
                        <b-btn variant="primary" @click="filter" class="btn-block">
                            <i class="fa fa-filter"></i> Filtrar
                        </b-btn>
                    </b-col>
                    <b-col cols="12" md="3">
                        <b-btn variant="secondary" @click="clearFilters" class="btn-block">
                            <i class="fa fa-times-circle"></i> Limpiar
                        </b-btn>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>
<script>
import FormSelectInput from '../../UI/Controls/Forms/FormSelectInput.vue';
import FormTextInput from '../../UI/Controls/Forms/FormTextInput.vue';
import SubTitle from '../../UI/Layout/SubTitle.vue';

export default {
    components: {
        appFormSelectInput: FormSelectInput,
        appFormTextInput: FormTextInput,
        appSubTitle: SubTitle
    },
    props: {
        onFilter: {
            type: Function,
            required: true
        },
        onClearFilters: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            type: '',
            name: '',
            typeOptions: [
                { id: 'incidente', name: 'Incidente' },
                { id: 'riesgo', name: 'Riesgo' }
            ]
        };
    },
    methods: {
        filter() {
            const filters = {};
            if (this.type) {
                filters.type = this.type;
            }
            if (this.name) {
                filters.name = this.name;
            }
            this.onFilter(filters);
        },
        clearFilters() {
            this.type = '';
            this.name = '';
            this.onClearFilters();
        }
    }
};
</script>

